/*
 * @description: configure redux store
 */

if (process.env.REACT_APP_ENV === 'dev') {
  module.exports = require('./configureStore.prod');
} else {
  module.exports = require('./configureStore.dev');
}
